import { IconWrapper } from '../runtime';
export default IconWrapper('letter-descending', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.2534 1.74976V14.2498M12.2534 14.2498L10.4404 12.4678M12.2534 14.2498L14.0664 12.4678",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M3.75 5.99976H6.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 7.24976L4.97308 1.91437C5.07564 1.66822 5.42436 1.66822 5.52692 1.91437L7.75 7.24976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 9.74976H7.35C7.6383 9.74976 7.76064 10.1168 7.53 10.2898L2.97 13.7098C2.73936 13.8827 2.8617 14.2498 3.15 14.2498H7.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});